import { v4 as uuidv4 } from 'uuid';

export function generateProductBulletPointItem() {
  return {
    id: uuidv4(),
    value: '',
    infoIcon: null,
  };
}
